import { apiDomain } from "env";

const cartaNegativa = payload =>
  `${apiDomain("portal/beneficiario")}/cartas_negativa/baixar?` +
  `${
    payload?.codigoBeneficiario
      ? `codigoBeneficiario=${payload?.codigoBeneficiario}&`
      : ""
  }` +
  `${payload?.numeroGuia ? `numeroGuia=${payload?.numeroGuia}` : ""}`;

const protocoloDetalhe = payload =>
  `${apiDomain("portal/beneficiario")}/protocolos?codigoBeneficiario=${
    payload?.codigoBeneficiario
  }&numeroProtocolo=${payload?.numeroProtocolo}`;

const protocoloGrid = payload =>
  `${apiDomain("portal/beneficiario")}/protocolos/grid?` +
  `${
    payload?.codigoBeneficiario
      ? `codigoBeneficiario=${payload?.codigoBeneficiario}&`
      : ""
  }` +
  `${payload?.cpf ? `cpf=${payload?.cpf}&` : ""}` +
  `${
    payload?.numeroProtocolo
      ? `numeroProtocolo=${payload?.numeroProtocolo}&`
      : ""
  }` +
  `${payload?.numeroGuia ? `numeroGuia=${payload?.numeroGuia}&` : ""}` +
  `${payload?.dataInicial ? `dataInicial=${payload?.dataInicial}&` : ""}` +
  `${payload?.dataFinal ? `dataFinal=${payload?.dataFinal}&` : ""}` +
  `${
    payload?.tipoSolicitacao
      ? `tipoSolicitacao=${payload?.tipoSolicitacao}&`
      : ""
  }` +
  `${
    payload?.statusProtocolo
      ? `statusProtocolo=${payload?.statusProtocolo}&`
      : ""
  }` +
  `${payload?.page ? `page=${payload?.page}&` : ""}` +
  `${payload?.size ? `size=${payload?.size}` : ""}`;

const statusProtocolo = () =>
  `${apiDomain("portal/beneficiario")}/protocolos/status_protocolo`;

const tiposSolicitacao = () =>
  `${apiDomain("portal/beneficiario")}/protocolos/tipo_solicitacao`;

export default {
  cartaNegativa,
  protocoloDetalhe,
  protocoloGrid,
  statusProtocolo,
  tiposSolicitacao
};
